module.exports = __webpack_public_path__ + "img/icon3.50b65e9c.svg";